import { Modal, Space, Table, Typography } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { PaginationComponent } from "../../Common/Pagination/PaginationComponent";
import PermissionCheck from "../../Common/PermissionCheck";
import { useDeletePool, useFetchPools } from "../../entities/api";
import { useFetchPoolsPagination } from "../../entities/api/usePoolsAPI";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import { useHandlePagination } from "../../hooks/useHandlePagination";
import AddNewPool from "./AddNewPool";
import { getColumns } from "./columnsRepository";

const PermissionName = PermissionNames.POOL;

const TableToolbar = styled.div`
  display: flex;
  align-content: center;
  justify-content: space-between;
`;

const SeasonPools = () => {
  const { formatMessage } = useIntl();
  const [filteredData, setFilteredData] = useState([]);
  const params = useParams();
  const { pageSize, currentPage, handlePaginationChange, offset, pageSizeOptions } = useHandlePagination();
  const { data: poolsData, isLoading } = useFetchPoolsPagination({
    limit: pageSize,
    offset,
  });

  const data = useMemo(() => poolsData?.data || [], [poolsData?.data]);
  const nextLink = useMemo(() => poolsData?.links?.next, [poolsData?.links?.next]);
  const [modal, contextHolder] = Modal.useModal();

  const { mutate: deleteFn, isPending: isDeleteLoading } = useDeletePool();

  const handleDeleteIntent = (stageCode) => {
    modal.confirm({
      content: formatMessage({ id: "delete.item.confirm" }),
      okType: "danger",
      okText: formatMessage({
        id: "delete",
        defaultMessage: "Delete",
      }),
      onOk: () => deleteFn(stageCode),
    });
  };

  useEffect(() => {
    if (data) {
      setFilteredData(data);
    }
  }, [data]);

  return (
    <React.Fragment>
      {contextHolder}
      <Space direction="vertical" style={{ width: "100%" }}>
        <TableToolbar>
          <Typography.Title level={4}>
            {formatMessage({
              id: "pools",
            })}
          </Typography.Title>
          <Space
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <PermissionCheck permissionKeys={[PermissionName]} permissionOptions={[PermissionOperations.CREATE]}>
              <AddNewPool />
            </PermissionCheck>
          </Space>
        </TableToolbar>
        <Table
          dataSource={filteredData}
          columns={getColumns({
            formatMessage,
            customerId: params.customerId,
            sport: params.sport,
            seasonId: params.seasonId,
            organizationId: params.organizationId,
            handleDeleteIntent,
            refetch: () => {},
          })}
          size="small"
          pagination={{
            current: currentPage,
            defaultPageSize: pageSize,
            showSizeChanger: true,
            pageSizeOptions,
            showQuickJumper: false,
            total: nextLink ? offset + data.length + 1 : data.length + offset,
            position: ["bottomCenter"],
            onChange: handlePaginationChange,
            showTotal: (total, range) => (
              <PaginationComponent pageNumber={currentPage} pageSize={pageSize} total={total} range={range} />
            ),
          }}
          rowKey={(x) => x.poolCode}
          loading={isLoading || isDeleteLoading}
        />
      </Space>
    </React.Fragment>
  );
};

export default SeasonPools;
